<template>
  <div class="container p-5 d-none d-md-block">
    <div class="row justify-content-center position-relative">
      <div class="carousel">
        <div class="inner" ref="inner" :style="innerStyles">
          <div class="carouselCard" v-for="(card, index) in cards" :key="index">
            <div class="w-100 h-100">
              <div class="card border-0 bg-transparent me-3">
                <div class="card-body city-cards-desktop" @click="onSelect(card)" type="button">
                  <h4 class="card-title max-content text-primary font-P7 h4">
                    {{ card.name }}
                  </h4>
                  <p class="p-sm card-text max-content font-Pr4">Ver índice UV</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button @click="prev" class="arrow-prev"></button>
      <button @click="next" class="arrow-next"></button>
    </div>
  </div>
</template>

<script>
import CarouselMixin from '../../mixins/carouselMixin'

export default {
  mixins: [CarouselMixin],
  props: {
    provinces: Array
  },
  data() {
    return {
      cards: this.provinces
    }
  },

  methods: {
    onSelect(selected) {
      this.$emit('select-location', selected)
    }
  }
}
</script>